import { createAction } from 'redux-api-middleware'
import buildAsyncCall from './asyncCall'
import * as Helpers from './helpers'

const Types = {
    DASHBOARD_EVENTSPACE_DWELLTIMELINE: {
        request: 'DASHBOARD_EVENTSPACE_DWELLTIMELINE##REQUEST',
        success: 'DASHBOARD_EVENTSPACE_DWELLTIMELINE##SUCCESS',
        failure: 'DASHBOARD_EVENTSPACE_DWELLTIMELINE##FAILURE',
    },
    DASHBOARD_EVENTSPACE_PRODUCTS_TOP: {
        request: 'DASHBOARD_EVENTSPACE_PRODUCTS_TOP##REQUEST',
        success: 'DASHBOARD_EVENTSPACE_PRODUCTS_TOP##SUCCESS',
        failure: 'DASHBOARD_EVENTSPACE_PRODUCTS_TOP##FAILURE',
    },
    DASHBOARD_EVENTSPACE_INTERACTIONS: {
        request: 'DASHBOARD_EVENTESPACE_INTERACTIONS##REQUEST',
        success: 'DASHBOARD_EVENTESPACE_INTERACTIONS##SUCCESS',
        failure: 'DASHBOARD_EVENTESPACE_INTERACTIONS##FAILURE',
    },
    DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED: {
        request: 'DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED##REQUEST',
        success: 'DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED##SUCCESS',
        failure: 'DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED##FAILURE',
    },
    DASHBOARD_EVENTSPACE_STORES_TOP: {
        request: 'DASHBOARD_EVENTSPACE_STORES_TOP##REQUEST',
        success: 'DASHBOARD_EVENTSPACE_STORES_TOP##SUCCESS',
        failure: 'DASHBOARD_EVENTSPACE_STORES_TOP##FAILURE',
    },
    DASHBOARD_EVENTSPACE_CONTENT_TOP: {
        request: 'DASHBOARD_EVENTSPACE_CONTENT_TOP##REQUEST',
        success: 'DASHBOARD_EVENTSPACE_CONTENT_TOP##SUCCESS',
        failure: 'DASHBOARD_EVENTSPACE_CONTENT_TOP##FAILURE',
    },
    DASHBOARD_EVENTSPACE_FETCH_PRODUCTS: {
        request: 'DASHBOARD_EVENTSPACE_FETCH_PRODUCTS##REQUEST',
        success: 'DASHBOARD_EVENTSPACE_FETCH_PRODUCTS##SUCCESS',
        failure: 'DASHBOARD_EVENTSPACE_FETCH_PRODUCTS##FAILURE',
    },
}

/**
 * Fetch products information
 * @param {Array<String>} skus List of skus
 */
function fetchProductsInformation(skus) {
    const body = {
        query: `query getProducts($skus: [String]!) {
      timestamp
      getProducts(skus: $skus) {
        sku
        images {
          url
        }
        title
      }
    }`,
        variables: { skus },
    }

    return createAction({
        endpoint: 'https://dcg-pricing-api.volumenetwork.com/graphql',
        method: 'POST',
        body: JSON.stringify(body),
        types: [
            Types.DASHBOARD_EVENTSPACE_FETCH_PRODUCTS.request,
            Types.DASHBOARD_EVENTSPACE_FETCH_PRODUCTS.success,
            Types.DASHBOARD_EVENTSPACE_FETCH_PRODUCTS.failure,
        ],
    })
}

function fetchEventspaceDwellTimeline(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('eventspace/dwelltime/timeline', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_EVENTSPACE_DWELLTIMELINE.request,
            Types.DASHBOARD_EVENTSPACE_DWELLTIMELINE.success,
            Types.DASHBOARD_EVENTSPACE_DWELLTIMELINE.failure,
        ],
    })
}

function fetchEventspaceProductsTop(from, to) {
    return async (dispatch) => {
        const mainFetch = await dispatch(
            buildAsyncCall({
                endpoint: Helpers.buildUrl('eventspace/products/top', from, to),
                method: 'GET',
                types: [
                    Types.DASHBOARD_EVENTSPACE_PRODUCTS_TOP.request,
                    Types.DASHBOARD_EVENTSPACE_PRODUCTS_TOP.success,
                    Types.DASHBOARD_EVENTSPACE_PRODUCTS_TOP.failure,
                ],
            })
        )
        const { type, payload } = mainFetch

        if (type !== Types.DASHBOARD_EVENTSPACE_PRODUCTS_TOP.success) {
            return mainFetch
        }

        const skus = payload.map(({ sku }) => sku)
        await dispatch(fetchProductsInformation(skus))

        return mainFetch
    }
}

function fetchEventspaceInteractions(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('eventspace/interactions/total', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_EVENTSPACE_INTERACTIONS.request,
            Types.DASHBOARD_EVENTSPACE_INTERACTIONS.success,
            Types.DASHBOARD_EVENTSPACE_INTERACTIONS.failure,
        ],
    })
}

function fetchEventspaceInteractionsGrouped(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('eventspace/interactions/grouped', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED.request,
            Types.DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED.success,
            Types.DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED.failure,
        ],
    })
}

function fetchEventspaceStoresTop(from, to) {
    return async (dispatch) => {
        const mainFetch = await dispatch(
            buildAsyncCall({
                endpoint: Helpers.buildUrl('eventspace/stores/top', from, to, {
                    count: 5,
                }),
                method: 'GET',
                types: [
                    Types.DASHBOARD_EVENTSPACE_STORES_TOP.request,
                    Types.DASHBOARD_EVENTSPACE_STORES_TOP.success,
                    Types.DASHBOARD_EVENTSPACE_STORES_TOP.failure,
                ],
            })
        )
        const { type, payload } = mainFetch

        if (type !== Types.DASHBOARD_EVENTSPACE_STORES_TOP.success) {
            return mainFetch
        }

        const promises = await Promise.all(payload.map(({ store_code: storeCode }) => dispatch(Helpers.fetchStore(storeCode))))

        return [mainFetch, ...promises]
    }
}

function fetchEventspaceContentTop(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('eventspace/content/top', from, to),
        method: 'GET',
        types: [Types.DASHBOARD_EVENTSPACE_CONTENT_TOP.request, Types.DASHBOARD_EVENTSPACE_CONTENT_TOP.success, Types.DASHBOARD_EVENTSPACE_CONTENT_TOP.failure],
    })
}

export {
    Types,
    fetchEventspaceContentTop,
    fetchEventspaceDwellTimeline,
    fetchEventspaceInteractions,
    fetchEventspaceInteractionsGrouped,
    fetchEventspaceProductsTop,
    fetchEventspaceStoresTop,
}
